import styled, { keyframes } from 'styled-components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'

export const ProductPageModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
`;

export const ModalContainer = styled.div`
    background: ${props => props.hasImage ? `url(${props.src}) no-repeat center center / cover` : 'white'};
    padding: 20px;
    border-radius: 8px;
    max-width: 600px;
    width: 100%;
    height: auto;
    max-height: 600px;
    justify-content: center;
    align-items: middle;
    display: flex;
    margin-top: 150px;
    margin-bottom: 150px;
    flex-direction: column;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    @media screen and (max-width: 490px){
     margin-top: 100px;
     max-width: 600px;
     max-height: 1000px;
    }
`;

export const PageImage = styled.img`
  height: 200px;
  width: 200px; 
  z-index: 1;
`;

export const ModalHeader = styled.h2`
    margin: 0;
    margin-bottom: 10px;
    color: #c2b280;
    text-align: center;
`;

export const ModalBody = styled.div`
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-end;
`;

export const ModalFormLabel = styled.label`
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: bold;
  color: gray; //#500000;
  text-align: center;
  
  @media screen and (max-width: 490px){
    font-size: 14px;
  }

`;

export const ModalForm = styled.input`
  padding: 16px 16px;
  margin-bottom: 32px;
  border: none;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  min-width: 300px;
  background: rgba(255, 255, 255, 0.5); /* Semi-transparent background */
  color: #000; /* Text color to ensure visibility */
  

  &:focus {
    outline: none;
    border: 2px solid #c2b280;
  }
`;

export const ProductRow = styled.div`
  max-height: 250px;
  margin:20px;
  display: flex;
  justify-content: center;
`;

export const ProductImageWrap = styled.div`
  max-width: 250px;
  height: 100%;
`;

export const ProductImage = styled.img`
  height: 150px;
  width: 200px; 
  margin-top: 0;
  margin-right: 0;
  margin-left: 10px;
  padding-right: 0;

  
  @media screen and (max-width: 490px){
     max-width: 100px;
     max-height: 100px;
    }
`;

export const ProductDetailWrapper = styled.div`
  display: flex;
  width: 300px;
  margin-left: 20px;
  align-items: start;
  justify-content: right;
  flex-direction: column;
`;

export const ProductDescriptionText = styled.label`
  color: black;
  font-size: 12px;
  font-weight: bold;
  margin-top: 8px;
  margin-bottom: 8px;
  @media screen and (max-width: 490px){
    font-size: 10px;
    margin-top: 4px;
    margin-bottom: 4px;
  }
`;

export const ProductCost = styled.label`
  color: black;
  font-size: 16px;
  font-weight: bold;
  margin-top: 8px;
  margin-bottom: 8px;
  @media screen and (max-width: 490px){
    font-size: 14px;
    margin-top: 4px;
    margin-bottom: 4px;
  }
`;

export const ImageGrid = styled.div`
  display: flex;
  justify-content: space-between; /* Space images evenly */
  width: 100%;
`;

export const SelectableImage = styled.img` 
  width: 30%; /* Width of each image to fit three in a row */
  height: auto;
  cursor: pointer; 
  border: 2px solid transparent; 
  border-radius: 8px; 
  transition: border 0.3s; 
  
  &:hover { 
  border: 2px solid #c2b280; /* Highlight image on hover */ 
  } 
`;

export const ModalCenterButton = styled.button`
  border-radius: 50px;
  background: #c2b280;
  white-space: nowrap;
  padding: 2px 8px;
  color: #ffffff;
  font-size: 24px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }
`;

export const ModalOptionList = styled.div`
 align-items: center;
 display: flex;
 flex-direction: row;
`
export const ModalOptionButton = styled.button`
  border-radius: 10px;
  background-color: ${({ selected }) => (selected ? '#c2b280' : '#fff')};
  white-space: nowrap;
  padding: 2px 8px;
  color: ${({ selected }) => (selected ? '#fff' : '#c2b280')};;
  font-size: 16px;
  outline: none;
  border-color: #c2b280;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #c2b280;
    color: #fff;
  }
`;


export const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const ModalCloseButton = styled.button`
  border-radius: 50px;
  background: none;
  white-space: nowrap;
  padding: 2px 8px;
  color: #c2b280;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }
`;

export const ModalButton = styled.button`
  border-radius: 50px;
  background: #c2b280;
  white-space: nowrap;
  padding: 2px 8px;
  color: #ffffff;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIcon = styled(AiOutlineLoading3Quarters)`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #c2b280;
  border-radius: 50%; 
  width: 24px; 
  height: 24px; 
  animation: ${spin} 1s linear infinite;
`